'use client';

import { ButtonSecondary } from '@portals/ui-kit';
import { useTranslations } from 'next-intl';
import { useClientEnvContext } from '@/contexts';
import {
  TRANSLATION_NAMESPACE,
  APPEAL_TRANSLATIONS,
} from '@/_constants/translations';
import { useRouter } from '@/i18n/navigation';

export const NewAppealButton = () => {
  const t = useTranslations(TRANSLATION_NAMESPACE);
  const router = useRouter();
  const { CREATE_APPEAL_URL } = useClientEnvContext();

  const handleClickContinue = () => {
    router.push(CREATE_APPEAL_URL);
  };

  return (
    <ButtonSecondary
      text={t(APPEAL_TRANSLATIONS.continueButton)}
      modifier="circle"
      onClick={handleClickContinue}
    />
  );
};
